import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

import { Box, Card, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarEmoji } from '@factorialco/f0-react'
import { OneModal } from '@factorialco/f0-react/dist/experimental'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const CreateSurveyOptionModal = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const selectSurvey = () => {
    navigate(
      navigation.trainings.list.details_revamp.view.surveys.newSurvey.fullPath({
        id: Number(id),
      })
    )
  }
  const selectCustomTemplate = () => {
    navigate(
      navigation.trainings.list.details_revamp.view.surveys.selectCustomTemplate.fullPath({
        id: Number(id),
      })
    )
  }

  return (
    <OneModal
      isOpen
      onClose={() => {
        navigate(
          navigation.trainings.list.details_revamp.view.surveys.fullPath({
            id: Number(id),
          })
        )
      }}
    >
      <OneModal.Header title={i18n.t('trainings.surveys.create.new_survey_modal_title')} />
      <OneModal.Content withPadding>
        <Box gap={'s16'} flexDirection="row" justifyContent="spaceBetween">
          <Box
            borderRadius={{ all: 'abs016' }}
            gap={'s6'}
            flexDirection="column"
            height={'s200'}
            width={'s400'}
            onClick={selectSurvey}
          >
            <Card>
              <Card.Eyebrow>
                <F0AvatarEmoji emoji={'✏️'} size="lg" />
              </Card.Eyebrow>
              <Card.Content>
                <Box gap={'s4'} flexDirection="column">
                  <Text.Normal color="textPrimary" size="300" weight="semibold">
                    {i18n.t('trainings.surveys.create.start_from_scratch')}
                  </Text.Normal>

                  <Text.Normal color="grey700" size="300">
                    {i18n.t('trainings.surveys.create.start_from_cratch_description')}
                  </Text.Normal>
                </Box>
              </Card.Content>
            </Card>
          </Box>
          <Box
            borderRadius={{ all: 'abs016' }}
            gap={'s4'}
            flexDirection="column"
            height={'s200'}
            width={'s400'}
            onClick={selectCustomTemplate}
          >
            <Card>
              <Card.Eyebrow>
                <F0AvatarEmoji emoji={'📄'} size="lg" />
              </Card.Eyebrow>
              <Card.Content>
                <Box gap={'s4'} flexDirection="column">
                  <Text.Normal color="textPrimary" size="300" weight="semibold">
                    {i18n.t('trainings.surveys.create.use_a_template')}
                  </Text.Normal>

                  <Text.Normal color="grey700" size="300">
                    {i18n.t('trainings.surveys.create.use_a_template_description')}
                  </Text.Normal>
                </Box>
              </Card.Content>
            </Card>
          </Box>
        </Box>
      </OneModal.Content>
    </OneModal>
  )
}
export default CreateSurveyOptionModal
